module.exports = __webpack_public_path__ + "img/7K.8d11aa00.png";